import axios from "axios";

export const fetchData = async () => {
  let apiUrl = 'https://www.ratezip.com/rate-quotes/common/peklava-bankrateapi-deposits-nz-dev.php';

  try {
    const res = await axios({
      method: "get",
      url: apiUrl,
    });
    return {
      message: "success",
      data: res.data,
    };
  } catch (e) {
    return {
      message: "fail",
      data: [],
    };
  }
};